import { render, staticRenderFns } from "./homeSettle.vue?vue&type=template&id=0a61f37b&scoped=true"
import script from "./homeSettle.vue?vue&type=script&lang=js"
export * from "./homeSettle.vue?vue&type=script&lang=js"
import style0 from "./homeSettle.vue?vue&type=style&index=0&id=0a61f37b&prod&lang=scss"
import style1 from "./homeSettle.vue?vue&type=style&index=1&id=0a61f37b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a61f37b",
  null
  
)

export default component.exports